export const METADATA = {
    cacheName: {
        prefix: 'pplx',
        suffix: 'v2',
        runtime: 'runtime',
        html: 'html',
    },
};
export function getCacheNamePrefix(isRootServiceWorker) {
    return isRootServiceWorker ? METADATA.cacheName.prefix : `${METADATA.cacheName.prefix}-nova`;
}
export const CACHE_NAME_PREFIXES = [
    getCacheNamePrefix(true),
    getCacheNamePrefix(false),
];
export const CURRENT_URL_REQUEST_MESSAGE_TYPE = 'pplx:get-current-url';
export const NOTIFICATION_NAVIGATION_MESSAGE_TYPE = 'pplx:navigate-notification';
//# sourceMappingURL=metadata.js.map